import { toHtml, toText, isEmptyValue, escapeHtml } from '../editor/content.js';
import { clozeParts, clozeRegex } from '../editor/blanks.js';

export function clozeNumbers(text) {
  const nums = new Set();
  for (const part of clozeParts(text)) {
    if (part.n > 0) nums.add(part.n);
  }
  return [...nums].sort((a, b) => a - b);
}

/** Replace cloze markers in (already sanitized) HTML for card number `n`. */
export function renderCloze(html, n, side) {
  return html.replace(clozeRegex(), (_m, num, answer, hint) => {
    if (Number(num) !== n) return answer;
    if (side === 'front') {
      const label = hint ? escapeHtml(stripTags(hint)) : '…';
      return `<span class="cloze-gap">[${label}]</span>`;
    }
    return `<span class="cloze-reveal">${answer}</span>`;
  });
}

function stripTags(s) {
  return s.replace(/<[^>]*>/g, '');
}

function blankProblem(text) {
  const parts = clozeParts(text);
  if (!parts.length) return 'Add a blank: click a word and tap Blank, or type [[answer]].';
  if (parts.some((p) => !p.answer.trim())) return 'Type the hidden word inside each blank.';
  return null;
}

export const cloze = {
  id: 'cloze',
  name: 'Fill in the blank',
  short: 'Blanks',
  description: 'Hide words in a sentence. Each blank becomes a card.',
  icon: 'blank',
  fields: [
    {
      key: 'text',
      label: 'Sentence',
      hint: 'Click a word and tap Blank. Or type [[answer]].',
      kind: 'rich',
      required: true,
      placeholder: 'The pacemaker of the heart is [[SA node]].',
    },
    { key: 'extra', label: 'Extra info', hint: 'Shown with the answer.', kind: 'rich' },
  ],
  ords: (note) => clozeNumbers(toText(note.fields?.text)).map((n) => n - 1),
  cardLabel: (ord) => `Blank ${ord + 1}`,
  checks: {
    text: (v) => blankProblem(toText(v)),
  },
  summary: (n) => (n ? 'One for each blank' : 'Make a blank to create a card'),
  validate: (f) => {
    if (isEmptyValue(f.text)) return 'Text is empty.';
    return blankProblem(toText(f.text));
  },
  render: (note, ord) => {
    const html = toHtml(note.fields.text);
    const n = ord + 1;
    const extra = isEmptyValue(note.fields.extra)
      ? ''
      : `<hr class="answer-rule">${toHtml(note.fields.extra)}`;
    return {
      front: renderCloze(html, n, 'front'),
      back: renderCloze(html, n, 'back') + extra,
      mode: 'flip',
    };
  },
};
